import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/6ca8045b/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentCode = makeShortcode("ComponentCode");
const ComponentDocs = makeShortcode("ComponentDocs");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "content-switcher"
    }}>{`Content switcher`}</h2>
    <ComponentCode name="Content switcher" component="content-switcher" variation="content-switcher" hasReactVersion hasVueVersion="contentswitcher--default" hasAngularVersion="?path=/story/content-switcher--basic" codepen="QPybNw" mdxType="ComponentCode"></ComponentCode>
    <h2 {...{
      "id": "content-switcher-disabled"
    }}>{`Content switcher disabled`}</h2>
    <ComponentCode name="Content switcher disabled" component="content-switcher" variation="content-switcher--disabled" hasReactVersion hasVueVersion="contentswitcher--default&knob-with%20icon=true" hasAngularVersion="?path=/story/content-switcher--basic" codepen="OGMVxK" mdxType="ComponentCode"></ComponentCode>
    <h2 {...{
      "id": "documentation"
    }}>{`Documentation`}</h2>
    <ComponentDocs component="content-switcher" mdxType="ComponentDocs"></ComponentDocs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      